import PrivateRoute from '../containers/PrivateRoute'
import Acesso from '../containers/Acesso'
import Cliente from '../containers/Cliente'
import Empresa from '../containers/Empresa'
import Equipamento from '../containers/Equipamento'
import Monitorado from '../containers/Monitorado'
import Logs from '../containers/Logs'
import PerfilUsuario from '../containers/PerfilUsuario'
import PerfilCliente from '../containers/PerfilCliente'
import ConfiguracaoSistema from '../containers/ConfiguracaoSistema'
import Automacao from '../containers/Automacao'
import MinhaConta from '../containers/MinhaConta'
import Usuario from '../containers/Usuario'
import AcessoModulo from '../containers/AcessoModulo'
import ListaMonitorados from '../containers/ListaMonitorados'
import Alerta from '../containers/Alerta'
import Status from '../containers/Status'
import EquipamentoVirtual from '../containers/EquipamentoVirtual'
import ComandoCustomizado from '../containers/ComandoCustomizado'
import CampoParametrizado from '../containers/CampoParametrizado'
import Sideccr from '../containers/Ambiental/Sideccr'
import RelatorioCustomizado from '../containers/RelatorioCustomizado'
import RelatorioConsumo from '../containers/RelatorioConsumo'
import Mira from '../containers/Ambiental/Mira'
import RelatorioInema from '../containers/Ambiental/Relatorios/RelatorioInema/form.js'
import RelatorioSerhma from '../containers/Ambiental/Relatorios/RelatorioSerhma/form.js'
import AfiraLink from '../containers/AfiraLink/index.js'
import ExportacaoDados from '../containers/ExportacaoDados/index.js'
import RelatorioAlertas from '../containers/RelatorioAlertas/index.js'
import Ana from '../containers/Ambiental/Ana/index.js'

import DashboardLns from '../containers/LNS/Dashboard/index.js'
import Aplicacao from '../containers/LNS/Aplicacao/index.js'
import Gateway from '../containers/LNS/Gateway/index.js'
import PerfilDispositvo from '../containers/LNS/PerfilDispositivo/index.js'
import Planos from '../containers/LNS/Planos/index.js'
import Redirecionamentos from '../containers/LNS/Redirecionamentos/index.js'
import RelatorioFaturamento from '../containers/LNS/RelatorioFaturamento/index.js'
import RelatorioGateway from '../containers/LNS/RelatorioGateway/index.js'
import RelatorioDispositivo from '../containers/LNS/RelatorioDispositivo/index.js'
import Outorga from '../containers/Ambiental/Outorga/index.js'
import DashboardView from '../containers/Ambiental/Dashboard/index.js'
import GrantReport from '../containers/Ambiental/Relatorios/RelatorioOutorga/GrantReport.js'
import LnsQuickRegister from '../containers/LNS/CadastroRapido/index.js'

let key = 0
const getKey = () => {
    let value = key
    key += 1
    return value
}

const routes = [
    {
        route: "/acesso",
        cliente: false,
        component: <PrivateRoute key={getKey()} path='/acessos' component={Acesso} />
    },
    {
        route: "/acesso-modulo",
        cliente: false,
        component: <PrivateRoute key={getKey()} path='/acesso-modulo' component={AcessoModulo} />
    },
    {
        route: "/cliente",
        cliente: false,
        component: <PrivateRoute key={getKey()} path='/cliente' component={Cliente} />
    },
    {
        route: "/empresa",
        component: <PrivateRoute key={getKey()} path='/empresa' component={Empresa} />
    },
    {
        route: "/monitorado-status",
        component: <PrivateRoute key={getKey()} path='/status/:id' component={Status} />
    },
    {
        route: "/equipamento",
        cliente: false,
        component: <PrivateRoute key={getKey()} path='/equipamento' component={Equipamento} />
    },
    {
        route: "/monitorado",
        component: <PrivateRoute key={getKey()} path='/monitorado' component={Monitorado} />
    },
    {
        route: "/relatorio",
        component: <PrivateRoute key={getKey()} path='/relatorio-customizado' component={RelatorioCustomizado} />
    },
    {
        route: "/relatorio/consumo",
        component: <PrivateRoute key={getKey()} path='/relatorio-consumo' component={RelatorioConsumo} />
    },
    {
        route: "/log-acessos",
        component: <PrivateRoute key={getKey()} path='/relatorio/logs' component={Logs} />
    },
    {
        route: "/sideccr",
        component: <PrivateRoute key={getKey()} required='ambiental' path='/sideccr/' component={Sideccr} />
    },
    {
        route: "/mira",
        component: <PrivateRoute key={getKey()} required='ambiental' path='/mira' component={Mira} />
    },
    {
        route: "/equipamento",
        cliente: false,
        component: <PrivateRoute key={getKey()} path='/campo-parametrizado' component={CampoParametrizado} />
    },
    {
        route: "/usuario/perfil",
        component: <PrivateRoute key={getKey()} path='/perfil/usuario' component={PerfilUsuario} />
    },
    {
        route: "/cliente/perfil",
        component: <PrivateRoute key={getKey()} path='/perfil/cliente' component={PerfilCliente} />
    },
    {
        route: "/configuracao",
        component: <PrivateRoute key={getKey()} path='/configuracao-sistema' component={ConfiguracaoSistema} />
    },
    {
        route: "/configuracao-timezone",
        component: <PrivateRoute key={getKey()} path='/minha-conta' component={MinhaConta} />
    },
    {
        route: "/automacao",
        component: <PrivateRoute key={getKey()} path='/automacao' component={Automacao} />
    },
    /*{
        route: "",
        component: <PrivateRoute path='/automacao-grupo' component={Automacao} />
    },*/
    {
        route: "/usuario",
        component: <PrivateRoute key={getKey()} path='/usuario' component={Usuario} />
    },
    {
        route: "/lista-monitorado",
        component: <PrivateRoute key={getKey()} path='/lista-monitorados' component={ListaMonitorados} />
    },
    {
        route: "/equipamento",
        component: <PrivateRoute key={getKey()} path='/virtual' component={EquipamentoVirtual} />
    },
    {
        route: "/alerta",
        component: <PrivateRoute key={getKey()} path='/lista-alertas' component={Alerta} />
    },
    {
        route: "/equipamento",
        cliente: false,
        component: <PrivateRoute key={getKey()} exact path='/comando-customizado/:id/novo' component={ComandoCustomizado} />
    },
    {
        route: "/equipamento",
        cliente: false,
        component: <PrivateRoute key={getKey()} exact path='/comando-customizado/:idComando/editar/' component={ComandoCustomizado} />
    },
    {
        route: "/relatorio-ambiental-inema",
        component: <PrivateRoute key={getKey()} required='ambiental' path='/relatorio-inema' component={RelatorioInema} />
    },
    {
        route: "/relatorio-ambiental-serhma",
        component: <PrivateRoute key={getKey()} required='ambiental' path='/relatorio-serhma' component={RelatorioSerhma} />
    },
    {
        route: "/equipamento",
        cliente: false,
        component: <PrivateRoute key={getKey()} path='/afiralink' component={AfiraLink} />
    },
    {
        route: "/exportacao-dados",
        component: <PrivateRoute key={getKey()} path='/exportacao-dados' component={ExportacaoDados} />
    },
    {
        route: "/relatorio/alerta",
        component: <PrivateRoute key={getKey()} path='/relatorio-alertas' component={RelatorioAlertas} />
    }, 
    {
        route: "/ana",
        component: <PrivateRoute key={getKey()} required='ambiental' path='/ana' component={Ana}/>
    },
    {
        route: "/lns/dashboard",
        cliente: false,
        component: <PrivateRoute key={getKey()} required='lns' path='/lns/dashboard' component={DashboardLns}/>
    },
    {
        route: "/lns/application",
        component: <PrivateRoute key={getKey()} required='lns' path='/lns/application' component={Aplicacao}/>
    },
    {
        route: "/lns/gateway",
        cliente: false,
        component: <PrivateRoute key={getKey()} required='lns' path='/lns/gateway' component={Gateway}/>
    },
    {
        route: "/lns/device/profile",
        component: <PrivateRoute key={getKey()} required='lns' path='/lns/device/profile' component={PerfilDispositvo}/>
    },
    {
        route: "/lns/planos",
        cliente: false,
        component: <PrivateRoute key={getKey()} required='lns' path='/lns/planos' component={Planos}/>
    },
    {
        route: "/lns/redirecionamentos",
        component: <PrivateRoute key={getKey()} required='lns' path='/lns/redirecionamentos' component={Redirecionamentos}/>
    },
    {
        route: "/lns/relatorio/faturamento",
        cliente: false,
        component: <PrivateRoute key={getKey()} required='lns' path='/lns/relatorio/faturamento' component={RelatorioFaturamento}/>
    },
    {
        route: "/lns/relatorio/gateway",
        cliente: false,
        component: <PrivateRoute key={getKey()} required='lns' path='/lns/relatorio/gateway' component={RelatorioGateway}/>
    },
    {
        route: "/lns/relatorio/dispositivo",
        component: <PrivateRoute key={getKey()} required='lns' path='/lns/relatorio/dispositivo' component={RelatorioDispositivo}/>
    },
    {
        route: "/ambiental/outorga",
        component: <PrivateRoute key={getKey()} required='ambiental' path='/ambiental/outorga' component={Outorga} />
    },
    {
        route: "/ambiental/dashboard",
        component: <PrivateRoute key={getKey()} required='ambiental' path='/ambiental/dashboard' component={DashboardView} />
    },
    {
        route: "/ambiental/relatorio/outorgas",
        component: <PrivateRoute key={getKey()} required='ambiental' path='/ambiental/relatorio/outorgas' component={GrantReport} />
    },
    {
        route: "/lns/cadastro-rapido",
        component: <PrivateRoute key={getKey()} required='lns' path='/lns/cadastro-rapido' component={LnsQuickRegister} />
    },
]

export default routes